import React from 'react';
import SectionSlider from './section-slider';
import SectionObject from './section-object';
import RepeatableSegment from "../repeatableSegment/repeatableSegment";
import presentationDescriptionSvg from  './../../svg/presentation_description_book.svg'
// @ts-ignore
import style from './presentaionDescription/presentationDescription.module.scss';
// @ts-ignore
import stylePDF from  './../../../src/Download/downloadPDF.module.scss'
import {formatInternationalPhoneNumber, getPluralForm} from "../helpers";

type MainProps = {
    data: any,
    hasDownloadRoute: boolean
}

const Main:React.FC<MainProps> = ({data, hasDownloadRoute}) => {
    const totalObjects = data.presentation.reduce(
        (sum: number, collection: any) => sum + collection.apartments.length,
        0
    );
    const totalComplexes = data.presentation.length;

    const objectLabel = getPluralForm(totalObjects, ['объект', 'объекта', 'объектов']);
    const complexLabel = getPluralForm(totalComplexes, ['ЖК', 'ЖК', 'ЖК']);

    let sectionSliderCounter = 1;

    const agentFields = {
        name: data?.agent?.name,
        phone: data?.agent?.phone,
        email: data?.agent?.email,
    }

    return (
        <main id="pdfContent" className="max-w-[842px] w-full mx-auto py-[100px] max-md:py-[12px] flex flex-col max-md:gap-[0px]">
            {
                hasDownloadRoute ?
                    <div className={`${stylePDF.mainSlide} pdf-slide`}>
                        <div className={stylePDF.presentationDescriptionDownload}>
                            <p className={stylePDF.presentationDescriptionDownload__text}>
                                Подобрали<br/>
                                <span className={stylePDF.presentationDescriptionDownload__textHighlight}>
                                    {totalObjects} {objectLabel}
                                </span>
                                <span> в {totalComplexes} {complexLabel}</span>
                            </p>
                        </div>
                        <div className={stylePDF.mainSlide__footer}>
                            <ul className={stylePDF.mainSlide__list}>
                                {data?.agent && Object.entries(agentFields).map(([key, value]) => (
                                    value && (
                                        <li
                                            key={key}
                                            className={`
                                                        ${stylePDF.mainSlide__listItem} 
                                                        ${key === 'name' ? stylePDF.mainSlideValueBold : stylePDF.mainSlideValue}
                                                    `}
                                        >
                                            {
                                                key === 'phone' ? formatInternationalPhoneNumber(value, 'RU') : value
                                            }
                                        </li>
                                    )
                                ))}
                            </ul>
                            <div className={stylePDF.mainSlideDate}>
                                <p className={stylePDF.mainSlideValue}>Дата предложения</p>
                                <p className={stylePDF.mainSlideValueBold}>
                                    {new Date().toLocaleDateString('ru-RU')} {' '}
                                </p>
                            </div>
                        </div>
                    </div> :
                    <div className={'max-md:px-[12px] mb-[20px] max-md:mb-[0px]'}>
                        <div className={style.presentationDescription}>
                            <img src={presentationDescriptionSvg} alt="presentation-description-book"/>
                            <span className={style.presentationDescription__text}>
                            Подобрали {totalObjects} {objectLabel} в {totalComplexes} {complexLabel}
                        </span>
                        </div>
                    </div>
            }
            {
                data.presentation.map((collection: any, _idx: number) => {
                    const currentIndex = sectionSliderCounter++;

                    return (
                        <div id={data.presentation.length > 1 && _idx > 0 ? 'repeatableSegmentSection' : ''}>
                            {
                               hasDownloadRoute ?
                                    <>
                                        <React.Fragment key={`collection-${collection.id || currentIndex}`}>
                                            <SectionSlider
                                                images={collection.images}
                                                data={{housing_complex: collection}}
                                                dataAgent={data?.agent}
                                                mapData={collection?.map_infrastructure}
                                                slideIndex={currentIndex}
                                                lots={collection.apartments.length}
                                                hasDownloadRoute={true}
                                            />

                                            {collection.apartments.map((apartment: any) => (
                                                <div key={`apartment-slide-${apartment.id}`} className={`pdf-slide`}>
                                                    <SectionObject
                                                        data={{ apartments: [apartment] }}
                                                        dataAgent={data?.agent}
                                                        slideIndex={sectionSliderCounter++}
                                                        hasDownloadRoute={true}
                                                    />
                                                </div>
                                            ))}
                                        </React.Fragment>
                                    </>
                                    :
                                    // предпросмотр
                                    <RepeatableSegment key={`collection-${collection.id || currentIndex}`}>
                                        <SectionSlider
                                            images={collection.images}
                                            data={{ housing_complex: collection }}
                                            mapData={collection?.map_infrastructure}
                                            slideIndex={currentIndex}
                                            lots={collection.apartments.length}
                                            hasDownloadRoute={false}
                                        />

                                        {collection.apartments.map((apartment: any) => (
                                            <SectionObject
                                                key={`apartment-${apartment.id}`}
                                                data={{ apartments: [apartment] }}
                                                dataAgent={data?.agent}
                                                slideIndex={sectionSliderCounter++}
                                                hasDownloadRoute={false}
                                            />
                                        ))}
                                    </RepeatableSegment>
                            }
                        </div>
                    );
                })
            }
        </main>
    );

};

export default Main;